import _ from 'lodash'

export function checkConfig(paths: Record<string, any>) {
    const counted = _.countBy(paths)
    // const r = _.pickBy(counted, x => x > 1)
    // console.log(r)
    return _.pickBy(paths, v => counted[v] === 1)
}
